// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AppPage_container__5kV8S {
  display: flex;
  position: relative;
  max-width: 100vw;
}
.AppPage_container__5kV8S > :first-child {
  align-self: stretch;
}

.AppPage_ghost__2i3vV {
  width: 20vw;
}
@media only screen and (max-width: 62.5em) {
  .AppPage_ghost__2i3vV {
    width: 0;
  }
}

.AppPage_appright__FbFDS {
  box-sizing: border-box;
  padding: 3rem 3rem;
  width: 80vw;
}
@media only screen and (max-width: 62.5em) {
  .AppPage_appright__FbFDS {
    width: 100%;
  }
}

.AppPage_topside__6Eu7D {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}
.AppPage_topside_1__tBdsp {
  display: flex;
  align-items: center;
}
.AppPage_topside_1__tBdsp > :not(:last-child) {
  margin-right: 3rem;
}
.AppPage_topside_welcome__13qU2 {
  font-size: var(--default-font-small);
  line-height: 1.8rem;
}
.AppPage_topside_name__7zj2X {
  color: var(--color-primary);
  font-size: var(--default-font-subtitle);
  font-weight: 700;
  line-height: 3rem;
}
.AppPage_topside_icon__i8-cz {
  display: flex;
  align-items: center;
}
@media only screen and (max-width: 31.25em) {
  .AppPage_topside_icon__i8-cz {
    margin-bottom: 1rem;
  }
}
.AppPage_topside_icon_main__SY6EV {
  display: flex;
  align-items: center;
}
@media only screen and (max-width: 31.25em) {
  .AppPage_topside_icon_main__SY6EV {
    flex-direction: column-reverse;
  }
}
.AppPage_topside_tier__\\+gV3o {
  box-sizing: border-box;
  font-size: 1rem;
  padding: 0.7rem;
  color: var(--color-white);
  background-color: var(--color-error);
  border-radius: 1rem;
  margin-right: 1rem;
}
@media only screen and (max-width: 31.25em) {
  .AppPage_topside_tier__\\+gV3o {
    margin-right: 2.7rem;
  }
}
.AppPage_topside__6Eu7D h3 {
  font-size: var(--default-font-h3);
  line-height: 3.6rem;
}
@media only screen and (max-width: 37.5em) {
  .AppPage_topside__6Eu7D h3 {
    font-size: var(--default-font-subtitle);
  }
}

.AppPage_menuIcon__tSBZq {
  font-size: 3rem;
  color: var(--color-primary);
  cursor: pointer;
}
.AppPage_menuIcon__tSBZq:focus, .AppPage_menuIcon__tSBZq:hover {
  color: var(--color-primary-4);
}

.AppPage_mobileSidebar__\\+Qfgp {
  width: 100vw;
  height: 100vh;
  background-color: rgba(42, 40, 40, 0.7);
  position: fixed;
  display: grid;
  grid-template-columns: 40vw 60vw;
  z-index: 100;
}
@media only screen and (max-width: 37.5em) {
  .AppPage_mobileSidebar__\\+Qfgp {
    grid-template-columns: 60vw 40vw;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Components/AppPage.module.scss"],"names":[],"mappings":"AAEA;EACC,aAAA;EACA,kBAAA;EACA,gBAAA;AADD;AAGC;EACC,mBAAA;AADF;;AAKA;EACC,WAAA;AAFD;AAIC;EAHD;IAIE,QAAA;EADA;AACF;;AAIA;EACC,sBAAA;EACA,kBAAA;EACA,WAAA;AADD;AAGC;EALD;IAME,WAAA;EAAA;AACF;;AAKA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAFD;AAIC;EACC,aAAA;EACA,mBAAA;AAFF;AAIE;EACC,kBAAA;AAFH;AAMC;EACC,oCAAA;EACA,mBAAA;AAJF;AAOC;EACC,2BAAA;EACA,uCAAA;EACA,gBAAA;EACA,iBAAA;AALF;AAQC;EACC,aAAA;EACA,mBAAA;AANF;AASE;EALD;IAME,mBAAA;EAND;AACF;AAQE;EACC,aAAA;EACA,mBAAA;AANH;AAQG;EAJD;IAKE,8BAAA;EALF;AACF;AASC;EACC,sBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;EACA,oCAAA;EACA,mBAAA;EACA,kBAAA;AAPF;AAUE;EAVD;IAWE,oBAAA;EAPD;AACF;AAUC;EACC,iCAAA;EACA,mBAAA;AARF;AAUE;EAJD;IAKE,uCAAA;EAPD;AACF;;AAWA;EACC,eAAA;EACA,2BAAA;EACA,eAAA;AARD;AAUC;EAEC,6BAAA;AATF;;AAaA;EACC,YAAA;EACA,aAAA;EACA,uCAAA;EACA,eAAA;EACA,aAAA;EACA,gCAAA;EACA,YAAA;AAVD;AAYC;EATD;IAUE,gCAAA;EATA;AACF","sourcesContent":["@import '../variables/breakpoints';\n\n.container {\n\tdisplay: flex;\n\tposition: relative;\n\tmax-width: 100vw;\n\n\t&> :first-child {\n\t\talign-self: stretch;\n\t}\n}\n\n.ghost {\n\twidth: 20vw;\n\n\t@media only screen and (max-width: $bp-1000) {\n\t\twidth: 0;\n\t}\n}\n\n.appright {\n\tbox-sizing: border-box;\n\tpadding: 3rem 3rem;\n\twidth: 80vw;\n\n\t@media only screen and (max-width: $bp-1000) {\n\t\twidth: 100%;\n\t}\n\n\n}\n\n.topside {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tmargin-bottom: 2rem;\n\n\t&_1 {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\n\t\t&> :not(:last-child) {\n\t\t\tmargin-right: 3rem;\n\t\t}\n\t}\n\n\t&_welcome {\n\t\tfont-size: var(--default-font-small);\n\t\tline-height: 1.8rem;\n\t}\n\n\t&_name {\n\t\tcolor: var(--color-primary);\n\t\tfont-size: var(--default-font-subtitle);\n\t\tfont-weight: 700;\n\t\tline-height: 3rem;\n\t}\n\n\t&_icon {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\n\n\t\t@media only screen and (max-width: $bp-500) {\n\t\t\tmargin-bottom: 1rem;\n\t\t}\n\n\t\t&_main {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\n\t\t\t@media only screen and (max-width: $bp-500) {\n\t\t\t\tflex-direction: column-reverse;\n\t\t\t}\n\t\t}\n\t}\n\n\t&_tier {\n\t\tbox-sizing: border-box;\n\t\tfont-size: 1rem;\n\t\tpadding: 0.7rem;\n\t\tcolor: var(--color-white);\n\t\tbackground-color: var(--color-error);\n\t\tborder-radius: 1rem;\n\t\tmargin-right: 1rem;\n\n\n\t\t@media only screen and (max-width: $bp-500) {\n\t\t\tmargin-right: 2.7rem;\n\t\t}\n\t}\n\n\th3 {\n\t\tfont-size: var(--default-font-h3);\n\t\tline-height: 3.6rem;\n\n\t\t@media only screen and (max-width: $bp-600) {\n\t\t\tfont-size: var(--default-font-subtitle);\n\t\t}\n\t}\n}\n\n.menuIcon {\n\tfont-size: 3rem;\n\tcolor: var(--color-primary);\n\tcursor: pointer;\n\n\t&:focus,\n\t&:hover {\n\t\tcolor: var(--color-primary-4);\n\t}\n}\n\n.mobileSidebar {\n\twidth: 100vw;\n\theight: 100vh;\n\tbackground-color: rgba(#2a2828, 0.7);\n\tposition: fixed;\n\tdisplay: grid;\n\tgrid-template-columns: 40vw 60vw;\n\tz-index: 100;\n\n\t@media only screen and (max-width: $bp-600) {\n\t\tgrid-template-columns: 60vw 40vw;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AppPage_container__5kV8S`,
	"ghost": `AppPage_ghost__2i3vV`,
	"appright": `AppPage_appright__FbFDS`,
	"topside": `AppPage_topside__6Eu7D`,
	"topside_1": `AppPage_topside_1__tBdsp`,
	"topside_welcome": `AppPage_topside_welcome__13qU2`,
	"topside_name": `AppPage_topside_name__7zj2X`,
	"topside_icon": `AppPage_topside_icon__i8-cz`,
	"topside_icon_main": `AppPage_topside_icon_main__SY6EV`,
	"topside_tier": `AppPage_topside_tier__+gV3o`,
	"menuIcon": `AppPage_menuIcon__tSBZq`,
	"mobileSidebar": `AppPage_mobileSidebar__+Qfgp`
};
export default ___CSS_LOADER_EXPORT___;
